import {Badge} from 'antd'
import classNames from 'classnames'
import {LocalContext} from 'modules/local/LocalContext'
import Translate from 'modules/local/Translate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {staticPaths} from 'routes/staticPaths'
import {NullAsDefault} from 'views/Shared'
import {LoginContext} from "../../components/LoginContext";
import {BsBellFill, BsSearch} from "react-icons/bs";
import {IoChatbubblesSharp} from "react-icons/io5";

const defaultItems = [
  // {
  //   label: 'introduce',
  //   to: {
  //     pathname: '/start',
  //   },
  // },
  // {
  //   label: 'discovery',
  //   to: {
  //     pathname:
  //       staticPaths.discovery.pathname,
  //   },
  // },
]

const DefaultActions = () => {
    const history = useHistory()
    const {lang} = useContext(LocalContext)
    const login = useContext(LoginContext)

    return (
        <div className="flex md:hidden gap-6 flex-center">
            <Link to={staticPaths.messages}>
                <Badge dot={login?.count_msg_notifications > 0 && true} className="flex custom-badge-header">
                    <IoChatbubblesSharp size={18} className="text-color-500"/>
                </Badge>
            </Link>
            <Link to={{pathname: '/notifications'}}>
                <Badge dot={login?.count_notifications > 0 && true} className="flex custom-badge-header">
                    <BsBellFill
                        size={16}
                        className={classNames("text-color-500", login?.count_notifications > 0 && 'animate-ring')}
                    />
                </Badge>
            </Link>
            <BsSearch
                size={16}
                className="text-color-300"
                onClick={() => {
                    history.push({
                        pathname: staticPaths.search.pathname,
                        state: {isModal: true,},
                    })
                }}
            />
        </div>
    )
}

const HeaderNavigation = ({items = defaultItems, ExtraActions = NullAsDefault}) => (
  <React.Fragment>
    <Translate>
      {(t) => (
        <nav className="hidden md:flex items-center">
          {items.map(({label, to}, index) => (
            <h2 key={index}>
              <Link
                to={to.pathname}
                className={classNames(
                  'px-6 font-bold uppercase 111-111',
                  index === 0
                    ? 'color-primary'
                    : 'text-color-200 hover:text-primary'
                )}>
                {t(label)}
              </Link>
            </h2>
          ))}
        </nav>
      )}
    </Translate>
    <div className="flex items-center">
      <DefaultActions/>
      <ExtraActions/>
    </div>
  </React.Fragment>
)
export default HeaderNavigation
